import axiosClient from "utils/api/axios-client";

export default {
  getAll: (params) => {
    const url = "/api/v1/bike/places";
    return axiosClient.get(url, { params });
  },
  get: (id) => {
    const url = `/api/v1/bike/places/${id}`;
    return axiosClient.get(url);
  },
  create: (place) => {
    const url = `/api/v1/bike/places/`;
    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };
    return axiosClient.post(url, place, config);
  },
  update: (id, place) => {
    const url = `/api/v1/bike/places/${id}`;
    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };
    return axiosClient.put(url, place, config);
  },
  delete: (id) => {
    const url = `/api/v1/bike/places/${id}`;
    return axiosClient.delete(url);
  },
};
